import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAirwallexBatchPaymentForm.BillsInformation.AddBeneficiaryPopupContent.Fields',
    {
        inputFieldPlaceholder: 'Enter a value',
        selectFieldPlaceholder: 'Select a value',
    }
);
